import {
  Badge,
  Box,
  Button,
  Flex,
  Grid,
  Loader,
  LoadingOverlay,
  TextInput,
  Title,
  Text,
  MultiSelect,
  ComboboxItem,
} from "@mantine/core";
import {
  IconBarcode,
  IconBrandBootstrap,
  IconBriefcase,
  IconBuildingWarehouse,
  IconFileTypeCsv,
  IconListDetails,
  IconPackage,
  IconSearch,
} from "@tabler/icons-react";
import {
  MantineReactTable,
  MRT_ColumnDef,
  MRT_RowSelectionState,
  useMantineReactTable,
} from "mantine-react-table";
import _breadcrumb from "../../../_base/component/_layout/_breadcrumb";
import {
  useDebouncedState,
  useDebouncedValue,
  useDisclosure,
  useHotkeys,
} from "@mantine/hooks";
import { _localization } from "../../../config/location";
import { useDeferredValue, useEffect, useState } from "react";
import React from "react";
import { useLocation } from "react-router-dom";
import { MessageResponse } from "../../../model/MessageResponse";
import {
  repositoryDelivery,
  repositoryPos,
} from "../../../_base/_const/_constVar";
import { BASE_API_DELIVERY } from "../../../config";
import { NotificationExtension } from "../../../_base/extension/NotificationExtension";
import { green } from "../../../const/variables";
import {
  changeSearchValue,
  getValueById,
} from "../../../_base/helper/FunctionHelper";
import { getMasterOrgSelect } from "../../../service/getSelectApi";

type ColumnPinningType = {
  left?: string[];
  right?: string[];
};

const InventoryReportCompanyV2 = () => {
  const headerRef = React.useRef<HTMLDivElement>(null);
  const [data, setData] = useState<any[]>([]);
  const [isError, setIsError] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isRefetching, setIsRefetching] = useState(false);
  const [rowCount, setRowCount] = useState(0);
  const [height, setHeight] = useState(0);
  const [rowSelection, setRowSelection] = useState<MRT_RowSelectionState>({});
  const [pagination, setPagination] = useState({
    pageIndex: 0,
    pageSize: 20,
  });
  const rowSelectionDeferred =
    useDeferredValue<MRT_RowSelectionState>(rowSelection);
  const [selectIds, setSelectIds] = useState<string[]>([]);
  const [visible, { toggle, open, close }] = useDisclosure(false);

  const location = useLocation();
  const _searchJson = sessionStorage.getItem(String(location.pathname))
    ? JSON.parse(sessionStorage.getItem(String(location.pathname)) ?? "")
    : null;
  const checkedPinSearch = localStorage.getItem("checkedPinSearch") == "true";
  const [isCallFirst, setIsCallFirst] = useState<boolean>(false);
  const [search, setSearch] = useState<any>({
    BranchCode: _searchJson && checkedPinSearch ? _searchJson.BranchCode : [],
    InvCode: _searchJson && checkedPinSearch ? _searchJson.InvCode : [],
    ItemCode: _searchJson && checkedPinSearch ? _searchJson.ItemCode : [],
    MaLoais: _searchJson && checkedPinSearch ? _searchJson.MaLoais : [],
    MaChungs: _searchJson && checkedPinSearch ? _searchJson.MaChungs : [],
    MaNganh: _searchJson && checkedPinSearch ? _searchJson.MaNganh : [],
  });
  const [keySearch, setKeySearch] = useDebouncedState<string>(
    _searchJson && checkedPinSearch ? _searchJson?.keySearch : "",
    300,
  );

  const [searchItem, setSearchItem] = useState<string>("");
  const [debounceSearchItem] = useDebouncedValue<string>(searchItem, 300);
  const [searchCatSegment4d, setSearchCatSegment4d] = useState<string>("");
  const [debounceCatsegment4d] = useDebouncedValue<string>(
    searchCatSegment4d,
    300,
  );

  const [dataBranch, setDataBranch] = useState<any[]>([]);
  const [dataWareHouse, setDataWareHouse] = useState<ComboboxItem[]>([]);
  const [dataItem, setDataItem] = useState<ComboboxItem[]>([]);
  const [dataCatSegment2b, setDataCatSegment2b] = useState<ComboboxItem[]>([]);
  const [dataCatSegment3c, setDataCatSegment3c] = useState<ComboboxItem[]>([]);
  const [dataCatSegment4d, setDataCatSegment4d] = useState<ComboboxItem[]>([]);

  const columns = React.useMemo<MRT_ColumnDef<any>[]>(
    () => [
      {
        accessorKey: "maSp",
        header: "Mã sản phẩm",
        Cell: ({ renderedCellValue }) => (
          <>
            <Badge
              radius="sm"
              variant="dot"
              size="lg"
              style={{ cursor: "pointer" }}
              color={renderedCellValue === null ? "red" : green.base}
            >
              {renderedCellValue ?? "Không có mã sản phẩm"}
            </Badge>
          </>
        ),
      },
      {
        accessorKey: "branchCode",
        header: "Mã chi nhánh",
        size: 150,
        Cell: ({ renderedCellValue }) => (
          <>
            <Button
              variant="light"
              p="4px 8px"
              radius="xl"
              size="xs"
              color="violet"
              fw="bold"
            >
              {renderedCellValue}
            </Button>
          </>
        ),
      },
      {
        accessorKey: "branchName",
        header: "Tên chi nhánh",
      },
      {
        accessorKey: "maKho",
        header: "Mã kho",
        size: 150,
        Cell: ({ renderedCellValue }) => (
          <>
            <Button
              variant="light"
              p="4px 8px"
              radius="xl"
              size="xs"
              color="blue"
              fw="bold"
            >
              {renderedCellValue}
            </Button>
          </>
        ),
      },
      {
        accessorKey: "tenKho",
        header: "Tên kho",
        size: 225,
      },
      {
        accessorKey: "tenSp",
        header: "Tên sản phẩm",
        size: 400,
        Cell: ({ renderedCellValue }) => (
          <>
            <Text truncate="end" fw={500}>
              {renderedCellValue}
            </Text>
          </>
        ),
      },
      {
        accessorKey: "dvt",
        header: "Đơn vị tính",
      },
      {
        accessorKey: "countSoLuong",
        header: "Tổng số lượng",
        Footer: ({ table }: any) => {
          const total = table
            .getRowModel()
            .rows.reduce(
              (sum: number, row: any) =>
                sum + (row.original?.countSoLuong || 0),
              0,
            );
          return (
            <div>
              <Text c="red" fw={800}>
                {total}
              </Text>
            </div>
          );
        },
      },
      {
        accessorKey: "maLoai",
        header: "Mã loại",
      },
      {
        accessorKey: "tenLoai",
        header: "Tên loại",
      },
      {
        accessorKey: "maChung",
        header: "Mã chủng",
      },
      {
        accessorKey: "tenChung",
        header: "Tên chủng loại",
        size: 200,
      },
      {
        accessorKey: "maNganh",
        header: "Mã ngành",
      },
      {
        accessorKey: "tenNganh",
        header: "Tên ngành",
        size: 200,
      },
      {
        accessorKey: "countSlChoXuat",
        header: "Tổng số lượng chờ xuất",
        Footer: ({ table }: any) => {
          const total = table
            .getRowModel()
            .rows.reduce(
              (sum: number, row: any) =>
                sum + (row.original?.countSlChoXuat || 0),
              0,
            );
          return (
            <div>
              <Text c="red" fw={800}>
                {total}
              </Text>
            </div>
          );
        },
        size: 225,
      },
    ],
    [],
  );

  const fetchData = async () => {
    if (
      (!search.BranchCode || search.BranchCode.length === 0) &&
      (!search.InvCode || search.InvCode.length === 0) &&
      (!search.ItemCode || search.ItemCode.length === 0) &&
      (!search.MaLoais || search.MaLoais.length === 0) &&
      (!search.MaChungs || search.MaChungs.length === 0) &&
      (!search.MaNganh || search.MaNganh.length === 0) &&
      (!keySearch || keySearch.length < 2)
    ) {
      NotificationExtension.Info(
        "Vui lòng nhập 1 trong các tham số tìm kiếm (Từ khóa chứa ít nhất 2 kí tự) !",
      );
    } else {
      setIsLoading(true);
      setIsRefetching(true);
      setIsError(false);
      try {
        let url = `/api/v1/TblInventorySerialOnhand/get-list-item?Skip=${
          pagination.pageIndex * pagination.pageSize
        }&Take=${pagination.pageSize}`;

        const params = new URLSearchParams();
        Object.entries(search).forEach(([key, value]) => {
          if (Array.isArray(value) && value.length > 0) {
            value.forEach((item) => params.append(key, String(item)));
          } else if (typeof value === "string" && value.length > 0) {
            params.append(key, value);
          }
        });

        if (keySearch.length > 0) {
          url += `&KeySearch=${keySearch?.trim()}`;
        }

        url += `&${params?.toString()}`;

        const res = await repositoryDelivery.get<MessageResponse<any>>(url);

        if (res && res.success) {
          const result = res.data;
          setData(result);
          setRowCount(res.totalCount);
          setIsCallFirst(true);
        } else {
          setData([]);
        }
      } catch (error) {
        setData([]);
        setIsError(true);
        console.error(error);
        return;
      } finally {
        setIsLoading(false);
        setIsRefetching(false);
        sessionStorage.setItem(
          String(location.pathname),
          JSON.stringify({
            ...search,
            keySearch: keySearch,
          }),
        );
      }
    }
  };

  const exportDataExcel = async () => {
    if (
      (!search.BranchCode || search.BranchCode.length === 0) &&
      (!search.InvCode || search.InvCode.length === 0) &&
      (!search.ItemCode || search.ItemCode.length === 0) &&
      (!search.MaLoais || search.MaLoais.length === 0) &&
      (!search.MaChungs || search.MaChungs.length === 0) &&
      (!search.MaNganh || search.MaNganh.length === 0) &&
      (!keySearch || keySearch.length < 2)
    ) {
      NotificationExtension.Info(
        "Vui lòng nhập 1 trong các tham số tìm kiếm (Từ khóa chứa ít nhất 2 kí tự) !",
      );
    } else {
      open();
      try {
        let url = `?Skip=${pagination?.pageIndex}&Take=${pagination.pageSize}`;

        const params = new URLSearchParams();
        Object.entries(search).forEach(([key, value]) => {
          if (Array.isArray(value) && value.length > 0) {
            value.forEach((item) => params.append(key, String(item)));
          } else if (typeof value === "string" && value.length > 0) {
            params.append(key, value);
          }
        });

        if (keySearch.length > 0) {
          url += `&KeySearch=${keySearch?.trim()}`;
        }

        url += `&${params.toString()}`;

        const baseUrl = `/api/v1/ExportExcel/export-inventory-report-all-branch${url}`;

        const _url = BASE_API_DELIVERY + baseUrl;
        const token = localStorage.getItem("token");

        const response = await fetch(_url, {
          method: "GET",
          headers: {
            "Content-Type": "application/vnd.ms-excel",
            Authorization: `Bearer ${token?.replace(`"`, "").replace(`"`, "")}`,
          },
        });

        if (!response.ok) {
          NotificationExtension.Fails("Export Excel thất bại !");
        } else {
          const blob = await response.blob();
          const urlss = window.URL.createObjectURL(blob);
          const _name = new Date().toISOString().slice(0, 10);
          let filename = "bao_cao_ton_kho_so_luong_toan_cong_ty.xlsx";
          const link = document.createElement("a");
          link.href = urlss;
          link.download = filename;
          document.body.appendChild(link);
          link.click();
          link.remove();
          window.URL.revokeObjectURL(url);
          NotificationExtension.Success("Export Excel thành công !");
        }
      } catch (error) {
        console.log(error);
      } finally {
        close();
      }
    }
  };

  const fetchDataBranch = async () => {
    const res = await getMasterOrgSelect();

    if (res) {
      const data = res
        ?.filter((item) => item.value && item.text && item.att1)
        ?.map((item) => ({
          label: `${item.att1} - ${item.text}`,
          value: String(item.att1),
          id: String(item.value),
        }));
      setDataBranch(data);
    }
  };

  const fetchDataWarehouse = async () => {
    const branchSearch = search.BranchCode.map(
      (item: string) =>
        `&BranchId=${getValueById(String(item), dataBranch, "id")}`,
    ).join("");

    const take = search?.BranchCode?.length * 50;

    const res = await repositoryDelivery.get<MessageResponse<any>>(
      `/api/v1/TblDmInventory/get-list-by-branchs?Skip=0&Take=${
        search?.BranchCode && search?.BranchCode?.length > 0 ? take : 1000
      }${branchSearch}`,
    );

    if (res && res.success) {
      const result = res.data;
      const data = result
        ?.filter((item: any) => item.idBranch && item.name)
        ?.map((item: any) => ({
          label: `${item.code} - ${item.name}`,
          value: String(item.code),
        }));
      setDataWareHouse(data);
    }
  };

  const fetchDataItem = async () => {
    try {
      let url = "";

      if (debounceSearchItem.length > 2) {
        url += `&ListItemCode=${debounceSearchItem}`;
      }

      if (
        search.ItemCode &&
        Array.isArray(search.ItemCode) &&
        search.ItemCode.length > 0
      ) {
        url +=
          "&" + search.ItemCode.map((i: any) => `ListItemCode=${i}`).join("&");
      }

      const response = await repositoryPos.get(
        `api/v1/TblItem/get-list?Skip=0&Take=100` + url,
      );
      if (response && response.success) {
        const transformedData = response.data
          ?.filter((item: any) => item.itemCode && item.itemName)
          .map((item: any) => ({
            label: item.itemCode + " - " + item.itemName,
            value: String(item.itemCode),
          }));
        const uniqueData = Array.from(
          new Set(transformedData.map((item: any) => item.value)),
        ).map((value) =>
          transformedData.find((item: any) => item.value === value),
        );
        setDataItem(uniqueData);
      }
    } catch (error) {
      console.error(error);
      return;
    }
  };

  const fetchDataCatSegment2b = async () => {
    const res = await repositoryPos.get<MessageResponse<any>>(
      "/api/v1/TblCatSegment2b/get-all",
    );

    if (res && res.success) {
      const data = res.data
        ?.filter((item: any) => item.codeString && item.name)
        ?.map((item: any) => ({
          label: `${item.codeString} - ${item.name}`,
          value: String(item.codeString),
        }));

      setDataCatSegment2b(data);
    }
  };

  const fetchDataCatSegment3c = async () => {
    const res = await repositoryPos.get<MessageResponse<any>>(
      "/api/v1/TblCatSegment3c/get-all",
    );

    if (res && res.success) {
      let data: ComboboxItem[] = [];
      if (search?.MaNganh && search?.MaNganh.length > 0) {
        data = res.data
          ?.filter(
            (item: any) =>
              item.codeString &&
              item.name &&
              search?.MaNganh.includes(String(item.segment2CodeString)),
          )
          ?.map((item: any) => ({
            label: `${item.codeString} - ${item.name}`,
            value: String(item.codeString),
          }));
      } else {
        data = res.data
          ?.filter((item: any) => item.codeString && item.name)
          ?.map((item: any) => ({
            label: `${item.codeString} - ${item.name}`,
            value: String(item.codeString),
          }));
      }

      setDataCatSegment3c(data);
    }
  };

  const fetchDataCatSegment4d = async () => {
    let url = `/api/v1/TblCatSegment4d/get-list?Skip=0&Take=100`;

    if (search?.MaLoai && search?.MaLoai?.length > 0) {
      url += `&listCodeSegmentString3=${search?.MaLoai}`;
    }

    if (debounceCatsegment4d.length > 2 && search?.MaChung?.length === 0) {
      url += `&KeySearch=${debounceCatsegment4d}`;
    } else {
      url += `&KeySearch=${debounceCatsegment4d?.split(" - ")[0]}`;
    }

    const res = await repositoryPos.get<MessageResponse<any>>(url);

    if (res && res.success) {
      const data = res.data
        ?.filter((item: any) => item.codeString && item.name)
        ?.map((item: any) => ({
          label: `${item.codeString} - ${item.name}`,
          value: String(item.codeString),
        }));

      setDataCatSegment4d(data);
    }
  };

  useEffect(() => {
    if (isCallFirst) {
      fetchData();
    }
  }, [pagination?.pageIndex, pagination?.pageSize]);

  useEffect(() => {
    Promise.all([fetchDataBranch(), fetchDataCatSegment2b()]);
  }, []);

  useEffect(() => {
    fetchDataWarehouse();
  }, [search.BranchCode]);

  useEffect(() => {
    if (debounceSearchItem.length > 2) {
      fetchDataItem();
    }
  }, [debounceSearchItem]);

  useEffect(() => {
    fetchDataCatSegment3c();
  }, [search.MaNganh]);

  useEffect(() => {
    fetchDataCatSegment4d();
  }, [search.MaLoais, debounceCatsegment4d]);

  const getColumnPinningStorage = () => {
    const columnPinningStorage = localStorage.getItem(
      "columnPinningInventoryReportCompanyV2",
    );
    return columnPinningStorage
      ? JSON.parse(columnPinningStorage)
      : {
          left: ["mrt-row-select", "mrt-row-numbers"],
          right: ["action"],
        }; // Giá trị mặc định
  };

  // Lưu columnPinning vào state
  const [columnPinning, setColumnPinning] = useState<ColumnPinningType>(
    getColumnPinningStorage(),
  );
  // Hàm lưu vào localStorage
  useEffect(() => {
    localStorage.setItem(
      "columnPinningInventoryReportCompanyV2",
      JSON.stringify(columnPinning),
    );
  }, [columnPinning]);

  useEffect(() => {
    //   startTransition(() => {
    const valuesList = Object.keys(rowSelectionDeferred);
    setSelectIds(valuesList);
    if (valuesList.length < 1) setSelectIds([]);
    else {
      const valuesList = Object.keys(rowSelectionDeferred);
      setSelectIds(valuesList);
    }
    //  });
  }, [rowSelectionDeferred]);

  useEffect(() => {
    const headerHeight = headerRef.current?.offsetHeight || 0;
    const handleResize = () => {
      setHeight(window.innerHeight - (175 + headerHeight));
    };

    handleResize(); // Set initial height
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const table = useMantineReactTable({
    columns,
    data,
    enableColumnResizing: false,
    positionToolbarAlertBanner: "bottom",
    enableRowNumbers: true,
    enableStickyFooter: true,
    //add custom action buttons to top-left of top toolbar
    enableTopToolbar: false,
    mantineTopToolbarProps: {
      style: {
        borderBottom: "3px solid rgba(128, 128, 128, 0.5)",
        marginBottom: 5,
      },
    },
    localization: _localization,
    enableRowSelection: true,
    getRowId: (row) => row.id?.toString(),
    initialState: {
      showColumnFilters: false,
      columnPinning: {
        // left: ["mrt-row-numbers", "maVt"],
        // right: ["action"],
        ...columnPinning,
      },
      columnVisibility: { id: true, phone: false, fax: false },
      density: "xs",
    },
    mantineTableContainerProps: {
      style: { maxHeight: height, minHeight: height },
    },
    enableStickyHeader: true,
    manualPagination: true,
    onColumnPinningChange: (newState) => {
      setColumnPinning(newState);
    },
    onRowSelectionChange: setRowSelection,
    rowCount: rowCount,
    onPaginationChange: setPagination,
    mantineTableBodyCellProps: ({ row }) => ({
      style: {
        fontWeight: "500", //conditional styling
        fontSize: "12.5px",
        padding: "5px 15px",
      },
    }),
    state: {
      isLoading,
      pagination: pagination,
      showAlertBanner: isError,
      showProgressBars: isRefetching,
      showSkeletons: isLoading, //loading for the first time with no data
      rowSelection,
      columnPinning,
    },
    mantineToolbarAlertBannerProps: isError
      ? { color: "red", children: "Lỗi tải dữ liệu !" }
      : undefined,
    mantinePaginationProps: {
      showRowsPerPage: true,
      withEdges: true,
      rowsPerPageOptions: ["20", "50", "100"],
    },
    paginationDisplayMode: "pages",
    enableColumnPinning: true,
    mantineTableProps: {
      striped: false,
    },
    columnFilterDisplayMode: "popover",
    mantineTableBodyRowProps: ({ row }) => ({
      style: { cursor: "pointer" },
    }),
  });

  useHotkeys([
    [
      "Enter",
      () => {
        fetchData();
      },
    ],
  ]);

  return (
    <>
      <div
        ref={headerRef}
        style={{
          width: "100%",
        }}
      >
        <LoadingOverlay
          visible={visible}
          zIndex={1000}
          overlayProps={{ radius: "sm", blur: 5 }}
          loaderProps={{
            children: (
              <Flex direction={"column"} align="center" gap="xs">
                <Loader type="dots" size={35}></Loader>
                {/* <Title size={15}> Đang upload tài liệu...</Title> */}
                <Title size={15}> Đang xử lý....</Title>
              </Flex>
            ),
          }}
        />
        <Flex justify={"space-between"} align={"center"} w={"100%"}>
          <_breadcrumb></_breadcrumb>
          <Flex gap={"md"}>
            <Button
              leftSection={<IconFileTypeCsv size={16} />}
              onClick={() => exportDataExcel()}
            >
              Export Excel
            </Button>
          </Flex>
        </Flex>
        <Grid mt={10} w={"100%"}>
          <Grid.Col span={{ base: 12, xs: 12, md: 6, lg: 2 }}>
            <TextInput
              placeholder="Nhập từ khóa tìm kiếm"
              defaultValue={keySearch}
              onChange={(e) => setKeySearch(e.currentTarget.value)}
              leftSection={<IconSearch color="#15aabf" />}
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  fetchData();
                }
              }}
            />
          </Grid.Col>
          <Grid.Col span={{ base: 12, xs: 12, md: 6, lg: 2 }}>
            <MultiSelect
              placeholder="Chi nhánh"
              data={dataBranch?.map((item) => ({
                label: item.label,
                value: item.value,
              }))}
              value={search.BranchCode || []}
              searchable
              clearable
              leftSection={<IconBrandBootstrap color="#15aabf" />}
              onChange={(e) => {
                changeSearchValue(e ? e : [], "BranchCode", setSearch);
              }}
              nothingFoundMessage="Không tìm thấy dữ liệu !"
            />
          </Grid.Col>
          <Grid.Col span={{ base: 12, xs: 12, md: 6, lg: 2 }}>
            <MultiSelect
              size="sm"
              placeholder="Kho"
              searchable
              clearable
              data={dataWareHouse}
              value={search.InvCode}
              onChange={(e) => {
                changeSearchValue(e ? e : [], "InvCode", setSearch);
              }}
              leftSection={<IconBuildingWarehouse size={20} color="#15aabf" />}
              nothingFoundMessage="Không tìm thấy dữ liệu !"
            />
          </Grid.Col>
          <Grid.Col span={{ base: 12, xs: 12, md: 6, lg: 2 }}>
            <MultiSelect
              placeholder="Mã sản phẩm"
              clearable
              searchable
              leftSection={<IconBarcode color="#15aabf" />}
              data={dataItem}
              searchValue={searchItem}
              onSearchChange={setSearchItem}
              value={search.ItemCode || []}
              onChange={(e) =>
                changeSearchValue(e ? e : [], "ItemCode", setSearch)
              }
              nothingFoundMessage={"Vui lòng nhập ít nhất 3 kí tự !"}
            />
          </Grid.Col>
          <Grid.Col span={{ base: 12, xs: 12, md: 6, lg: 2 }}>
            <MultiSelect
              placeholder="Ngành"
              clearable
              searchable
              leftSection={<IconBriefcase color="#15aabf" />}
              data={dataCatSegment2b}
              value={search.MaNganh || []}
              onChange={(e) =>
                changeSearchValue(e ? e : [], "MaNganh", setSearch)
              }
              nothingFoundMessage="Không tìm thấy dữ liệu !"
            />
          </Grid.Col>
          <Grid.Col span={{ base: 12, xs: 12, md: 6, lg: 2 }}>
            <MultiSelect
              placeholder="Loại"
              clearable
              searchable
              leftSection={<IconPackage color="#15aabf" />}
              value={search.MaLoais || []}
              data={dataCatSegment3c}
              onChange={(e) =>
                changeSearchValue(e ? e : [], "MaLoais", setSearch)
              }
              nothingFoundMessage="Không tìm thấy dữ liệu !"
            />
          </Grid.Col>
          <Grid.Col span={{ base: 12, xs: 12, md: 6, lg: 2 }}>
            <MultiSelect
              placeholder="Chủng"
              clearable
              searchable
              leftSection={<IconListDetails color="#15aabf" />}
              searchValue={searchCatSegment4d}
              onSearchChange={setSearchCatSegment4d}
              data={dataCatSegment4d}
              onChange={(e) =>
                changeSearchValue(e ? e : [], "MaChungs", setSearch)
              }
              nothingFoundMessage="Không tìm thấy dữ liệu !"
            />
          </Grid.Col>
          <Grid.Col span={{ base: 12, xs: 12, md: 6, lg: 2 }}>
            <Button
              onClick={() => fetchData()}
              leftSection={<IconSearch size={14} />}
            >
              Tìm kiếm
            </Button>
          </Grid.Col>
        </Grid>
      </div>
      <Box mt={10}>
        <MantineReactTable table={table} />
      </Box>
    </>
  );
};

export default InventoryReportCompanyV2;
